<template>
  <div class="section1">
    <!-- 
    <img src="./s1/mo.jpg" class="t0" />
   -->
   
   <div class="img">
    <div class="cloud">
    <cloud class="cloud1" />
    <cloud class="cloud2" />
    <cloud class="cloud3" />
    <cloud class="cloud4" />
    <cloud class="cloud5" />
    </div>
    <img src="./s1/city.png" class="city" />
    <yellow class="yellow" />
    <red class="red" />

    

    </div>
    <div class="txt">
     <svg xmlns="http://www.w3.org/2000/svg" data-aos="zoom-in" data-aos-delay="600" class="logo" viewBox="0 0 675 245" fill="#FFF">
      <path d="M55.1,240.1V211h9.1c0.5-1.6,0.8-3,1.1-4.3l4.5,0.4c-0.4,1.1-0.8,2.4-1.3,3.9h14v29.1h-3.9v-2.2H59.1v2.2C59,240.1,55.2,240.1,55.1,240.1z M59,214.3v4.7h19.6v-4.7H59z M59,222.2v4.7h19.6v-4.7H59z M59,230v4.7h19.6V230H59z M114.1,239.8v-27.2h12.6v-5.8h3.9v5.8h12.7v27.2h-3.8v-2.1h-21.7v2.1H114.1L114.1,239.8z M117.9,216.1v7.4h8.8v-7.4H117.9z M117.9,226.8v7.5h8.8v-7.5H117.9z M139.6,216.1h-8.9v7.4h8.9V216.1z M130.6,226.8v7.5h8.9v-7.5H130.6z M171.8,218.2v-3.3h3.1v-8.1h3.4v8.1h2.8v3.3h-2.8v11.7c0,0,0.3-0.1,0.7-0.1c0.4-0.2,1.1-0.5,2.1-0.8c0,0.6,0.2,2.6,0.1,3.5c-1.9,0.5-5,1.6-9.2,3.1l-0.5-3.8l3.5-0.8v-12.7L171.8,218.2L171.8,218.2z M201.6,239.6c-2.2,0-3.9-1.6-5-4.9c-1.5,1.6-3.3,3.3-5.5,5.2c-0.8-1.1-1.6-1.9-2.4-2.5c2.6-1.9,4.9-4,6.7-6.4c-0.8-3-1.3-7.9-1.7-14.9h-8v4.3h6.4c0,3.2-0.1,6.6-0.3,10c0.3,4.2-2.9,4.5-6,4.4c0-0.6-0.4-2.8-0.6-3.5h1.8c1.3,0.1,1.9-0.5,1.8-1.8c0.1-1,0.1-3.1,0.1-6.1h-3.4c0.1,7.2-1.2,12.8-3.9,16.6c-0.7-0.2-2.6-1.4-3.2-1.7c5.3-6.6,3.4-16.8,3.8-25.5h11.3c-0.1-1.8-0.1-3.8-0.1-6.1h3.4c0,1.3,0.2,4.5,0.1,6.1h8.1v3.2h-8c0.1,3.4,0.5,9.6,0.8,10.9c1.4-2.4,2.6-5.1,3.5-7.9l2.9,1.2c-1.7,4.5-3.5,8.2-5.5,11.1c0,0.1,0.1,0.2,0.1,0.4c0,0.1,0.1,0.2,0.1,0.3c0.5,2.5,1.2,3.8,2.1,3.9c0.3,0,0.5-0.4,0.7-1.1c0.1-0.5,0.6-3.5,0.7-4.7c0.9,0.4,1.9,0.7,2.8,1C204.9,234.7,205.3,239.3,201.6,239.6L201.6,239.6z M202,212.7c-1.1-1.1-2.4-2.4-3.8-3.8l2.2-1.7c0.8,0.7,3.3,2.9,3.9,3.6L202,212.7L202,212.7z M240.2,240.1v-12.2h8.9v-3.3h-11.1c0,6.3-1.4,11.5-4.1,15.6l-3.1-2.6c3.6-5.3,3.3-8.4,3.5-15.7c0,0,0-13.5,0-13.5h28.4v9.8h-10.1v3.5h11.9v3.1h-11.9v3.3h9.4v12.2h-3.7v-1.8h-14.7v1.8H240.2L240.2,240.1z M238.1,211.2v3.6h21.1v-3.6H238.1z M238.1,217.9v3.5h11.1v-3.5H238.1z M243.9,230.9v4.6h14.7v-4.6H243.9z M310.4,221.1v4.9h-4.7v-4.9H310.4z M351.3,212.6v-2.8h5.7v-3.1h3.1v3.1h5.6v2.8h-5.6v2.6h4.9v13.9h-4.9v2.6h5.9v2.9h-5.9v5.2H357v-5.2h-6.2v-2.9h6.2v-2.6h-5v-13.9h5v-2.6H351.3z M354.6,217.8v3.2h2.7v-3.2H354.6z M354.6,223.4v3.3h2.7v-3.3H354.6z M362.5,217.8h-2.7v3.2h2.7V217.8z M359.8,223.4v3.3h2.7v-3.3H359.8z M367.4,239.9v-27h6.4v-6h3.1v6h6.6v27h-2.9v-2.2h-10.2v2.2H367.4L367.4,239.9z M370.4,216.1v7.7h3.5v-7.7H370.4z M370.4,226.9v7.9h3.5v-7.9H370.4z M380.6,216.1h-3.7v7.7h3.7V216.1z M376.9,226.9v7.9h3.7v-7.9H376.9z M414,231.8c-0.4-0.3-2.8-1-3.7-1.4c1.7-5,2.9-9.4,3.8-13.2l3.8,1.1C416.7,223,415.4,227.4,414,231.8z M425.2,238.8c-3.9,0.1-5.8-1.7-5.7-5.4v-19.2h4.1v18.4c-0.1,2,0.9,3,2.9,2.9c7.9,0.1,7.5,0.3,8.4-7.4c0.8,0.2,3.2,1.1,3.9,1.4C437.7,240.6,435,238.6,425.2,238.8L425.2,238.8z M430.6,217.4c-1.7-1.9-4.3-4.6-7.9-8.1l2.7-2.6c3.2,2.8,5.8,5.3,8,7.7L430.6,217.4z M441,229.6c-1.7-3.4-3.7-7.2-5.9-11.4l3.4-1.8c1.7,3,3.7,6.7,6.2,11.3L441,229.6z M474.3,227.1v-9.8c-0.8,1-1.8,2.1-2.9,3.2c-0.3-1.3-0.7-2.6-1.1-3.9c2.9-2.9,5.1-6.3,6.7-10.2l3.4,1.2c-0.5,1-2.1,4.1-2.7,5v14.3H474.3z M473.6,237.8c-0.4-0.2-2.1-1.2-3.2-1.4c1.3-2.5,2.3-5,3.1-7.5l3.4,1C475.9,232.7,474.8,235.3,473.6,237.8L473.6,237.8z M483.6,239.4c-3.3,0.1-4.9-1.4-4.7-4.5v-6.1h3.7v5.2c0.1,1.6,1,2.3,2.7,2.2h4.7c2.1,0.1,3.1-0.5,3.2-1.8c0.1-0.9,0.5-2.3,0.5-3.1c0.1,0,0.3,0.1,0.5,0.3c1.4,0.5,2.4,0.8,3.1,1c-0.2,0.8-0.7,3-1,3.5c-0.5,2.3-2.4,3.4-5.5,3.3L483.6,239.4L483.6,239.4z M480.6,224.6v-14.1h3.2v14.1H480.6z M488.7,233.4c-0.9-1.1-2.5-2.6-4.6-4.6l2.1-1.8c-0.6-0.6-1.4-2.4-1.8-2.8c3.1-0.8,5.5-1.8,7.3-2.9c-1.1-1.5-2.1-3.2-2.9-5.2c-0.7,0.8-1.4,1.7-2.2,2.5c-0.3-0.5-1.8-2.3-2-2.8c2.7-2.8,4.7-5.8,5.9-9.2l3.4,0.5c-0.4,1-0.8,1.9-1.3,2.8h10.6v3.1h-2.2c-1,3.6-2.4,6.4-4.2,8.2c1.8,1.1,4.2,2,7.3,2.6c-0.3,0.5-1.5,2.4-1.8,3.2c-3-0.8-5.7-2-8-3.6c-1.8,1.4-4.2,2.5-7.3,3.5c1.2,1,3.9,3.4,4.6,4.2L488.7,233.4L488.7,233.4z M494.2,219.2c1.4-1.5,2.4-3.5,3.1-6.1H491C491.8,215.6,492.9,217.7,494.2,219.2z M500.9,236.9c-0.7-1.2-2.9-5.2-4.1-7.2l3.1-1.4c1.6,2.5,3,4.9,4.2,7.2L500.9,236.9z M535.7,220.8c-1.5-1.1-4.6-3.4-5.7-4.2l2.1-2.4c1.5,0.8,3.4,2.1,5.7,3.9L535.7,220.8L535.7,220.8z M531.6,239.9l-1.7-3.6c1.5-1.2,2.8-2.4,3.9-3.5v-7h-3.4v-3.3h6.7v10.2c1.6,2.3,4.3,3.5,8,3.5c8.4,0,14.7-0.1,19-0.1c-0.4,0.9-0.8,2-1.1,3.2c-8.8,0-15-0.1-18.8-0.1c-3.8,0.1-6.7-1.1-8.7-3.5C535.1,236,532.8,238.6,531.6,239.9L531.6,239.9z M536.4,214c-1.1-1-3.5-3-5.7-4.3l2.1-2.4c1.3,0.8,4.5,3,5.7,3.9L536.4,214z M539,214.4v-2.9h4.1V207h3.4v4.5h3.8v2.9h-6.2c0,0.8-0.2,2.9-0.1,3.9h5.9c-0.1,2.6-0.3,10.1-0.4,11.8c0.1,4.3-3.2,4.3-6.4,4.2c-0.2-1-0.4-2-0.7-3.1c1.7,0.2,4.6,0.6,4.4-1.7c0.1-0.9,0.4-6.5,0.4-8.4h-3.2c-0.1,5-1.3,9.3-3.5,12.8c-0.8-0.8-1.5-1.5-2.4-2.2c3-4.3,3.1-11.6,3.1-17.4L539,214.4L539,214.4z M550.8,226V223h5.2v-1.1l3.1-3.1h-6.7v-1.8l-0.5,0.7c-0.3-0.3-1.9-1.8-2.4-2.1c1.9-2.2,3.4-5.2,4.6-8.9l3.5,0.4c-0.4,1.1-0.8,2.1-1.3,3.1h7.6v2.9h-8.9c-0.5,0.8-1.1,1.8-1.8,2.9h9.8v2.9l-3.7,3.6v0.4h4.7v2.9h-4.7c-0.1,6.7,1.3,8.9-7.1,8.6c0-1-0.2-2.1-0.5-3.2c1.6,0,4.7,1,4.5-1.7c0,0,0-3.8,0-3.8H550.8z"/>
      <path d="M245.1,41h18.2l2.2-12.5h-7.1c-2.3,0-3.8-2.1-3.4-4.6l3.6-20.4H236l-3.6,20.1C230.7,33.2,236.4,41,245.1,41z M389,19.7L409.6,2h-17.8c-5.6,0-11,2.1-15.4,6l-18.6,16.5c-2.9,2.6-6.5,4-10.3,4h-40.6L311.3,4h-20.5l-4.3,24.4H273L270.8,41h13.4l-14.9,83.9c-0.5,2.8-2.5,3.6-5,3.6h-6.9l-3.3,18.7h23c5.1,0,9.5-4,10.5-9.5l11.2-63.2h19.1l-9.1,51.2c-0.5,2.8-2.7,4.8-5.2,4.8h-8l3.3,16.8h19.9c5.1,0,9.5-4,10.5-9.5l14-78.8h-41.7l3.2-17.9h51.4c7.1,0.2,13.5-3.8,18.5-8.7h50.6l2.2-12.5L389,19.7L389,19.7z M396,83.1l23.1-27l1.3-7.5h-63l-3,16.8h31.1L373,83.1l-1.8,10.1h-28.6l-3.2,17.9H368l-2.4,13.5c-0.6,3.2-3.4,5.8-6.3,5.8h-21.6l3.3,16.8h27.9c8.7,0,17.1-7.8,18.8-17.4l3.3-18.7h19.4c4,0,8-3.6,8.8-8.1l1.7-9.8h-26.7L396,83.1L396,83.1z M384.5,158.3H246.2c-2.3,0-3.8-2.1-3.4-4.6c3.1-17.6,17.4-98,18.3-103.2h-33.9L225,62.9h11.3l-13.4,75.7c-1.2,6.9-7.5,12.1-13.9,11.6l-4.4,25c10-0.2,19.8,1.7,28.2-5.7c2.2,3.5,6,5.7,10.6,5.7h138.9c16.4,0,25.8-17.1,26.8-32.8h-11.3C397,150.9,390.4,158.3,384.5,158.3z M615.9,69.9c-1,5.8-6.1,10.4-11.3,10.4l-1.3,7.5h9.4c10.4,0,20.5-9.3,22.5-20.8l2.2-12.3h-18.8L615.9,69.9z M597.4,157.3h-7.7c-2.5,0-4-2-3.5-4.8L605.9,41h14.6c5.5,0,10.9-2.1,15.2-5.9L669,9.3h-17.7c-5.6,0-11,2.1-15.3,6c-11.9,10.9-11.3,10.4-27.3,10.2L612.8,2h-22.6l-4.1,23.4h-84.8l-22.7,127.9c-0.5,2.8-2.7,4.8-5.2,4.8h-9.7l-2.8,15.6h28c5.1,0,9.5-4,10.5-9.5l13.5-76.3h25.4l-11.6,65.5c-0.5,2.8-2.7,4.8-5.2,4.8h-8.3l3.9,15.6h19.9c5.1,0,9.5-4,10.5-9.5l16.3-91.9h-48.1l5.5-31.2h62.2l-21.8,123.1c-1,5.5,2,9.5,7.1,9.5h32c17.1-0.6,19.6-19,21.5-32.8h-11.3C610.1,149.4,605,157.3,597.4,157.3z M477.6,119.1H460c2.9-4.8,5.4-25.6,6.7-31.2h16.5l2.8-15.6h-17.6c2.8-4.8,4.9-22.8,6.2-28.4H458l-4,22.6c-0.6,3.2-3.4,5.8-6.3,5.8h-11.2l-2.8,15.6h16.5l-4.5,25.4c-0.6,3.2-3.4,5.8-6.3,5.8h-11.2l-2.8,15.6h49.5L477.6,119.1z M70.3,22.3L93.5,2h-23c-7.2,0-14.2,2.7-19.9,7.8L34.2,24.2c-5.5,5.1-12,5.4-18.9,5.2l-4.4,25h11.3L1,173.7h160.4c10.5,0,20.7-9.4,22.8-21l23.1-130.4H70.3z M155.9,152.8c-0.6,3.2-3.4,5.8-6.3,5.8H31.9l4.4-24.5c0.6-3.2,3.4-5.8,6.3-5.8h117.7L155.9,152.8z M164,107.4c-0.6,3.2-3.4,5.8-6.3,5.8H40l4.4-24.5c0.6-3.2,3.4-5.8,6.3-5.8h117.7L164,107.4z M172,62c-0.6,3.2-3.4,5.8-6.3,5.8H48.1l2-11.2c2-11,10.8-19.1,20.9-19.1h105.4L172,62L172,62z"/>
    </svg>

      <div class="t1"  data-aos="zoom-in" data-aos-delay="600"><span v-if="isMobile">｜</span>22-39坪｜<br  v-if="isMobile" />稀有地段  正式公開</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/style/function.scss';

.section1 {
  width: 100%;
  height: 100vh;
  min-height: size(900);
  max-height: size(1080);
 // overflow: hidden;
  position: relative;
  background-image: linear-gradient(107.34deg, #E77600 0.31%, #EB9746 100%);
  background-size: 100% auto;
  &::before{
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: calc(50% + 18vw);
    background: linear-gradient(180deg, #B35921 0%, #CE7230 100%);
  }
}
.city{
  position: absolute;
  bottom:calc(50% + (10 - 540) * 100vw / 1920);
  right: size(105);
  width: size(921);
}
.cloud{
  position: absolute;
  top:50%;right: 0;
  width: 50%;
  font-size: size(20);
  .cloud1{
  position: absolute;
  fill: #FFF3;
  width:2.8em;
  top: -3.5em;left: 0.3em;
      transform:translateX(110%);
        animation: cloud 5s linear alternate infinite;
  }
  .cloud2{
  position: absolute;
  fill: #FFF4;
  width:4em;
  top: -10.15em;left:  5.5em;
      transform:translateX(100%);
        animation: cloud 5s linear alternate infinite;
  }
  .cloud3{
  position: absolute;
  fill: #FFF6;
  width:3.7em;
  top:  -16.25em;left: 13em;
      transform:translateX(120%);
        animation: cloud 5s linear alternate infinite;
  }
  .cloud4{
  position: absolute;
  fill: #FFF6;
  width:4em;
  top:-14.25em;left:23em;
      transform:translateX(150%);
        animation: cloud 5s linear alternate infinite;
  }
  .cloud5{
  position: absolute;
  fill: #FFF3;
  width:2.8em;
  top: -8em;left:34em;
      transform:translateX(80%);
        animation: cloud 5s linear alternate infinite;
  }
  @keyframes cloud{
    to{
      transform:translateX(0);
    }
}
  }
.yellow{
  position: absolute;
  right: size(130);
  bottom:calc(50% + (-40 - 540) * 100vw / 1920);
  width: size(534);
}
.red{
  position: absolute;
  right: size(605);
  bottom:calc(50% + (-10 - 540) * 100vw / 1920);
  width: size(330);
}
.t0{
  position: absolute;
  width: 100%;height:auto;
  top:0;
  left:0;object-fit: cover;
  opacity: .5;
  }
  /* .img{
    position: absolute;
    bottom:6%;left: calc(50% + 5vw);
    height:65%;
  }
  .img1{
    position: relative;
    height: 100%;
  } */
  .light8{
  position: absolute;
    width: 20%;
    bottom: 38%;
    left: 25%;
      animation: light3 2s linear infinite;
  }
@keyframes light3{
    0%{
      transform:rotate(-90deg) scale(0);opacity: 1;
    }
    50%{
      transform:rotate(0deg)  scale(1.5,.8);opacity: 1;
    }
    100%{
      transform:rotate(90deg)  scale(.8,1.5);opacity: 0;
    }
}

.txt{
  position: relative;
  // top:calc(50% + (253 - 540) * 100vw / 1920);
 //  left:size(-260);
 top:calc(37% + (315 - 1080 * 0.37) * 100vw / 1920);
  font-size: size(46);
  line-height: 1.35;
  color: #fff;
  text-align: center;
 // width:size(850);
    letter-spacing:0.02em;
    padding: 0 20em 0 0;
  font-weight: 300;
  filter: drop-shadow(0 0.1em 0.1em #00000026);

.logo{
  position: relative;
  margin:0 auto 1em;
  width:size(668);
  }
  
  .t1{
  font-size:1em;
  font-weight: 700;
    }
}
/* 螢幕尺寸標準 */
/* 平板尺寸 */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
}

@media screen and (max-width: 767px) {
  .section1 {
    min-height: sizem(604);
    max-height: sizem(750);
    height: calc(100vh - 63px);
  &::before{
    top:calc(80% + (582 - 667 * .8) * 100vw / 375);
  }
  }
.city{
  bottom:calc(20% + (5 - 667 * .2) * 100vw / 375);
  right: sizem(-13);
  width: sizem(400);
}
  
.cloud{
  position: absolute;
  top: calc(50% + 25vw);right: 0;
  width: 100%;
  font-size: sizem(9);
}
.yellow{
  right: sizem(6);
  bottom:calc(20% + (-45 - 667 * .2) * 100vw / 375);
  width: sizem(225);

}
.red{
  right:auto;
  left:sizem(7);
  bottom:calc(20% + (-35 - 667 * .2) * 100vw / 375);
  width: sizem(168);
}
.txt{
  font-size: sizem(25);
  top:calc(20% + (75 - 667 * .2) * 100vw / 375);
  line-height: 1.5;
    padding: 0;
.logo{
  width:sizem(290);
  margin:0 auto 0.2em;
  }
}


}
</style>
<script>
// @ is an alias to /src
import info from '@/info'
import { isPC, isMobile, isTablet } from '@/utils'
import yellow from './yellow.vue'
import red from './red.vue'
import cloud from './cloud.vue'

export default {
  name: 'section1',
  components: {
    yellow,
    red,
    cloud,
  },

  data() {
    return {
      info,
      isPC,
      isMobile,
      isTablet,
    }
  },

  methods: {},

  mounted() {},

  created() {},

  computed: {},
}
</script>
